import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {OMAveragePriceUpdateRequestDialog} from "app/skin/om/dialog/component/OmAveragePriceUpdateRequestDialogComponent";
import {EquityPositionViewModel} from "app/account/equity/models/EquityPositionViewModel";

export class OmAveragePriceUpdateRequestDialog {

    public static readonly id = "omAveragePriceUpdateRequestDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {
    }

    public async open(position: EquityPositionViewModel): Promise<void> {

        const settings: IModalSettings = {
            component: OMAveragePriceUpdateRequestDialog,
            resolve: {
                position: () => position
            }
        };
        const instance = this.$uibModal.open(settings);
        return instance.result;
    }
}